import {
  filter,
  findIndex,
  forEach,
  map,
  remove,
  find
} from 'lodash';
import app from '../../angular_app.es6';

app.controller('QuestionController', [ '$scope', 'Notification', '$timeout', '$element', '$rootScope',
  ($scope, Notification, $timeout, $element, $rootScope) => {
    $scope.form = {};
    $scope.options = {};
    $scope.selectIsOpened = false;

    $scope.sortableOptions = {
      items: '.-handle'
    };

    $scope.init = (data, options, notification) => {
      $scope.form = data;
      $scope.options = options;
      $scope.numberLimit = $scope.options.number_limit;

      if (notification) {Notification.error(notification);}

      forEach($scope.form.screener_questions, (q) => {
        $scope.initConditionList(q);
      });
    };

    $scope.hasNumberLimit = () => { return !!$scope.options.number_limit; };

    $scope.filteredList = () => { return filter($scope.form.screener_questions, (q) => !q._destroy); };

    $scope.addQuestion = (event) => {
      event.preventDefault();

      if ($scope.hasNumberLimit() && $scope.filteredList().length >= $scope.numberLimit) {
        Notification.error(`You can add only ${$scope.numberLimit} questions at most`);
        return;
      }

      $scope.form.screener_questions.push({
        text: '',
        answers: [ null ],
        kind: '',
        condition: {},
        condition_list: [],
        answers_order: 'specific',
        multi_condition: 1
      });
    };

    $scope.delQuestion = (event, question) => {
      event.preventDefault();

      if (!question.id) {
        remove($scope.form.screener_questions, (q) => q == question);
      } else {
        question._destroy = true;
      }
    };

    $scope.addAnswer = (event, question, answer) => {
      event.preventDefault();
      question.answers.push(null);
    };

    $scope.delAnswer = (event, question, answer, index) => {
      event.preventDefault();

      if (question.answers.length <= 1) {
        Notification.error('You can not delete the last answer');
        return;
      }

      question.answers.splice(index, 1);

      const condtion_idx = findIndex(question.condition_list, (c) => { return c.index == index; });
      if (condtion_idx > -1) {question.condition_list.splice(condtion_idx, 1);}

      const mustSelectListLength = $scope.mustSelectList(question).length;
      if (question.multi_condition >= mustSelectListLength && mustSelectListLength > 1) {
        question.multi_condition = mustSelectListLength - 1;
      }
    };

    $scope.initConditionList = (question) => {
      const conditions = map(question.condition, (c, idx) => {
        const index = parseInt(idx, 10);

        return {
          index: index == -1 ? -1 : index - 1,
          cond: c
        };
      });

      question.condition_list = filter(conditions, (c) => { return !!c.cond; });
    };

    $scope.getConditionForQuestion = (question) => {
      const findConditionByIndex = (index) => {
        const cidx = findIndex(question.condition_list, (c) => { return c.index == index;});
        if (cidx == -1) {return null;}
        return question.condition_list[cidx].cond;
      };

      const generatedConditions = {};
      generatedConditions[-1] = findConditionByIndex(-1);

      forEach(question.answers, (answer, idx) => {
        generatedConditions[idx + 1] = findConditionByIndex(idx);
      });

      return generatedConditions;
    };

    $scope.$on('project-form-next-step', (event) => { $element.parent().submit(); });

    $scope.emptyListQuestions = () => {
      const empty = !$scope.filteredList().length;
      if (empty) {$rootScope.$broadcast('hideExamples');} else {$rootScope.$broadcast('showExamples');}

      return empty;
    };

    $scope.findConditionItem = (question, index) => {
      let found = find(question.condition_list, (el) => { return el.index == index; });
      if (!found) {
        found = { index, cond: '' };
        question.condition_list.push(found);
      }

      return found;
    };

    $scope.onOrderUpdate = (q) => {
      return (e, ui) => {
        const from = ui.item.sortable.index,
          to = ui.item.sortable.dropindex;

        forEach(q.condition_list, (el, index) => {
          const elIndex = parseInt(el.index);

          if (elIndex == from) {
            el.index = String(to);
          }

          if (from < to &&  from < elIndex  && elIndex <= to) {
            el.index = String(elIndex - 1);
          }

          if (from > to &&  to <= elIndex  && elIndex < from) {
            el.index = String(elIndex + 1);
          }
        });
      };
    };

    $scope.onSelectClick = () => {
      $scope.selectIsOpened = true;
    };

    $scope.kindName = (name) => {
      return $scope.options.kinds[name];
    };

    $scope.selectOption = (event, question, name) => {
      event.preventDefault();
      event.stopPropagation();
      question.kind = name;
      $scope.selectIsOpened = false;
    };

    $scope.mustSelectList = (question) => { return filter(question.condition_list, (item) => item.cond == 'is'); };

    $scope.showMultiOption = (question) => {
      return question.kind === 'Multi' && $scope.mustSelectList(question).length > 1;
    };

    $scope.multiConditionOptions = (question) => {
      const mustSelectListLength = $scope.mustSelectList(question).length;
      if (!question.cachedMultiOptions) {question.cachedMultiOptions = {};}

      if (question.cachedMultiOptions.num !== mustSelectListLength) {
        const listArr = [];
        listArr.length = mustSelectListLength - 1;
        const list = map(listArr, (item, index) => {
          return {
            value: index + 1,
            text: `${$scope.options.multi_condition.at_least} ${index + 1}`
          };
        });
        list.unshift(
          {
            value: 0,
            text: $scope.options.multi_condition.all
          }
        );
        question.cachedMultiOptions.list = list;
        question.cachedMultiOptions.num = mustSelectListLength;
      }
      return question.cachedMultiOptions.list;
    };

    forEach([ 'mouseup', 'touchend' ], (action) => {
      window.document.addEventListener(action, (event) => {
        if ($scope.selectIsOpened) {
          const container = $('.-select-options');
          if (!container.is(event.target) && container.has(event.target).length === 0) {
            $timeout(() => { $scope.selectIsOpened = false; });
          }
        }
      });
    });
  } ]);
